<template>
  <div id="model">
    <div>
      <div ref="cover" class="cover"></div>
      <div ref="allModel" class="allModel">
        <div
          :style="{
            width:
              minWidth === undefined || minWidth === null ? '800px' : minWidth,
          }"
          class="content"
        >
          <div class="modelHead t_c p_r">
            <span class="font20">{{
              title === undefined || title === null
                ? $t("common.prompt")
                : title
            }}</span>
            <i
              @click="cancelModel()"
              class="color_blue0070AD p_a pointer"
              style="font-size: 26px; right: 10px; transform: rotate(45deg)"
              >+</i
            >
          </div>
          <!--<div class="modelBody">-->
          <div>
            <slot> 没内容 </slot>
          </div>
          <div class="modelFoot">
            <div v-if="OnButton === 1">
              <button @click="confirmModel()" class="redButton m_r_10 m_l_10">
                确定
              </button>
            </div>
            <div v-if="OnButton === 2">
              <button @click="confirmModel()" class="redButton m_l_10 m_r_10">
                确定
              </button>
              <button @click="cancelModel()" class="cancelButton m_r_10 m_l_10">
                取消
              </button>
            </div>
            <div v-if="OnButton === 3">
              <button @click="confirmModel()" class="redButton m_l_10 m_r_10">
                继续开单
              </button>
              <button @click="cancelModel()" class="cancelButton m_r_10 m_l_10">
                返回修改
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'model',
  props: [
    'onButton',
    'minWidth',
    'title',
    'showModel'
  ],
  data () {
    return {
      OnButton: parseInt(this.onButton)
    }
  },
  created () { // vue 页面的生命周期 当我一进来页面之后 我先执行
  },
  mounted () { // vue 页面的生命周期 当我进来之后 且加载完资源了之后再执行
    // document.getElementById('managLeft').style.zIndex = 1
    // console.log(document.getElementById('managLeft').style.zIndex)
    const that = this
    setTimeout(function () {
      that.$refs.cover.style.opacity = 1
      that.$refs.allModel.style.opacity = 1
      that.$refs.allModel.style.top = '0px'
    }, 10)
  },
  methods: { // 所有的方法封装
    cancelModel () {
      const that = this
      that.$refs.cover.style.opacity = 0
      that.$refs.allModel.style.opacity = 0
      that.$refs.allModel.style.top = '-100px'
      setTimeout(function () {
        that.$emit('on-cancel', '')
      }, 500)
    },
    confirmModel () {
      this.$emit('on-confirm', '')
    },
    conTwoModel () {
      this.$emit('on-confirmTwo', '')
    }
  },
  destroyed () {
  },
  components: {
  },
  watch: {
    onButton (val) {
      this.OnButton = parseInt(val)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/myComponents/model.vue